Namespace 'Customer.Reports'

class Customer.Reports.OperatorAvailabilityReportMetric
  constructor: ({@title, @count = 123123, types, @className}) ->
    @setTypes(types)

  setTypes: (@types) =>
    @count = @types.reduce(((acum, type) -> acum + type.count), 0) if @types
